module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc39-149534d4ffddd207a57c30d2a90a39d5.jpg";